import {createUploadModalState, type UploadModalState} from '@shared/editAssistant/UploadModal'
import useLocalStateStore from '@shared/util/zustand-hook'
import {ColorModal, type ColorModalState, createColorModalState} from './ColorModal'
import {type CommonModalState, createCommonModalState} from './common'
import {createEmbedModalState, EmbedModal, type EmbedModalState} from './EmbedModal'
import {createFaceImageButtonState, FaceImageButton, type FaceImageButtonState} from './FaceImageButton'
import {createFontSizeModalState, FontSizeModal, type FontSizeModalState} from './FontSizeModal'
import {createLinkModalState, LinkModal, type LinkModalState} from './LinkModal'
import {createNtbrModalState, NtbrModal, type NtbrModalState} from './NtbrModal'
import {createPluginModalState, PluginModal, type PluginModalState} from './PluginModal'
import {createTableModalState, TableModal, type TableModalState} from './TableModal'
import {createTwitterModalState, TwitterModal, type TwitterModalState} from './TwitterModal'

export {EditAssistant} from './EditAssistant'
export {
    ColorModal,
    EmbedModal,
    FaceImageButton,
    FontSizeModal,
    LinkModal,
    NtbrModal,
    PluginModal,
    TableModal,
    TwitterModal,
}

type EditAssistantModalState = ColorModalState
                                & FontSizeModalState
                                & NtbrModalState
                                & TableModalState
                                & EmbedModalState
                                & TwitterModalState
                                & LinkModalState
                                & FaceImageButtonState
                                & PluginModalState
                                & UploadModalState
                                & CommonModalState

export function useEditAssistantLocalStateUseStore() {
    return useLocalStateStore<EditAssistantModalState>((set, get) => ({
        ...createColorModalState(set, get),
        ...createFontSizeModalState(set, get),
        ...createNtbrModalState(set, get),
        ...createTableModalState(set, get),
        ...createEmbedModalState(set, get),
        ...createTwitterModalState(set, get),
        ...createLinkModalState(set, get),
        ...createFaceImageButtonState(set, get),
        ...createPluginModalState(set, get),
        ...createUploadModalState(set, get),
        ...createCommonModalState(set, get),
    }))
}

